import(/* webpackMode: "eager" */ "/opt/build/repo/app/knowledge/page.tsx");
